import { ApiRoutes, AppPaginationOptions, QueryError, WithPagination } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { Domain, SearchConsoleSitemapDomainsQueryKeys } from '@/modules/Domains';
import { SearchConsoleSitemap } from '@/modules/DomainsApi';

export const useGetAllSearchConsoleSitemapDomainsQuery = (siteId: string, paginationOptions: AppPaginationOptions) =>
  buildQuery<
    WithPagination<Pick<Domain, 'id' | 'name' | 'isGoogleVerificated' | 'isSitesMain'>
  >, QueryError>(
    [SearchConsoleSitemapDomainsQueryKeys.GetAll, siteId, paginationOptions],
    async () => {
      const { data } = await apiExecutor.get(ApiRoutes.SiteDomainsSearchConsoleSitemap.replace(':siteId', siteId), {
        params: paginationOptions
      });
      return data;
    }
  );

export const useCheckByIdSearchConsoleSitemapDomainsQuery = (siteId: string, domainId: string) =>
  buildQuery<void, QueryError>([SearchConsoleSitemapDomainsQueryKeys.GetById, siteId, domainId], async () => {
    await apiExecutor.get(
      `${ ApiRoutes.SiteDomainsSearchConsoleSitemapById.replace(':siteId', siteId).replace(':domainId', domainId) }/check`
    );
  });

export const useGetByIdSearchConsoleSitemapDomainsQuery = (siteId: string, domainId: string) =>
  buildMutation<SearchConsoleSitemap | null, QueryError, void>([SearchConsoleSitemapDomainsQueryKeys.GetById, siteId, domainId], async () => {
    const { data } = await apiExecutor.get(
      ApiRoutes.SiteDomainsSearchConsoleSitemapById.replace(':siteId', siteId).replace(':domainId', domainId)
    );
    return data;
  });

export const useSubmitSitemapToAccountMutation = (siteId: string, domainId: string) =>
  buildMutation<void, QueryError, void>(
    [SearchConsoleSitemapDomainsQueryKeys.Submit, siteId, domainId],
    async () => {
      await apiExecutor.post<void>(ApiRoutes.SiteDomainsSearchConsoleSitemapById.replace(':siteId', siteId).replace(':domainId', domainId));
    }
  );
